<template>
    <div class="wrap-content customer-statistics-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-10 filter-title-section">
                    <h2>Customer Statistics</h2>
                </div>
                <div
                    v-if="hasScopes('export-customer-statistics')"
                    class="col-md-2 text-right d-none-print"
                >
                    <b-form-group>
                        <base-button
                            v-b-modal.export-report-popup
                            btn-label="Export"
                            btn-type="submit"
                            btn-variant="secondary"
                            class="btn-sm"
                        ></base-button>
                    </b-form-group>
                </div>
            </div>
        </div>

        <div id="stats-charts" class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                        <div class="card dashboard-card sm-radius">
                            <!-- customers by age group -->
                            <donut-graph
                                id="customer-by-age"
                                path="insights/customers/count"
                                :query="setQueryParams('age_group')"
                                legend-id="customerByAgeLegend"
                                graph-heading="Customers by Age Group"
                            >
                            </donut-graph>

                            <!-- customers by age group end-->
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6 mb-370-print">
                        <div class="card dashboard-card sm-radius">
                            <!-- customers by gender -->
                            <donut-graph
                                id="customers-by-gender"
                                path="insights/customers/count"
                                :query="setQueryParams('gender')"
                                legend-id="customersByGenderLegend"
                                graph-heading="Customers by Gender"
                            >
                            </donut-graph>

                            <!-- customers by gender end-->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-6 page-break-inside-avoid">
                        <div
                            class="
                                card
                                dashboard-card
                                sm-radius
                                page-break-inside-avoid
                            "
                        >
                            <!-- Customers by Work Type -->
                            <!-- Bar Graph -->
                            <bar-graph
                                id="customers-by-work-type"
                                class="page-break-inside-avoid"
                                path="insights/customers/count"
                                :query="setQueryParams('work_type')"
                                :rotate-graph="true"
                                graph-heading="Customers by Work Type"
                            ></bar-graph>
                            <!-- Customers by Work Type end-->
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6 mb-370-print">
                        <div class="card dashboard-card sm-radius">
                            <!-- Customers Account Opening by Month -->
                            <bar-graph
                                id="customers-account-by-month"
                                path="insights/customers/count"
                                :query="setQueryParams('month')"
                                :rotate-graph="true"
                                graph-heading="Customers Account Opening by Month"
                            ></bar-graph>
                            <!-- Customers Account Opening by Month -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-12">
                        <div class="card dashboard-card sm-radius">
                            <!-- Customers by Industry -->
                            <bar-graph
                                id="customers-by-industry"
                                path="insights/customers/count"
                                :query="setQueryParams('industry')"
                                :rotate-graph="false"
                                :label-rotation="0"
                                graph-heading="Customers by Industry"
                            ></bar-graph>
                            <!-- Customers by Industry end -->
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-md-12">
                        <donut-table-graph
                            id="customers-by-nationality"
                            legend-id="customersByNationalityLegend"
                            path="insights/customers/count"
                            :query="setQueryParams('nationality')"
                            graph-heading="HIGHEST NATIONALITY GROUP"
                        ></donut-table-graph>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-md-12">
                        <donut-table-graph
                            id="customers-by-residence"
                            legend-id="customersbyResidenceLegend"
                            path="insights/customers/count"
                            :query="setQueryParams('country_of_residence')"
                            graph-heading="HIGHEST COUNTRY OF RESIDENCE"
                        ></donut-table-graph>
                    </div>
                </div>
            </div>
        </div>
        <export-report-popup
            export-graph-id="stats-charts"
            file-name="Stats.pdf"
            :graph-ids="graphIds"
        ></export-report-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import exportReportPopup from '@/components/popups/ExportReportPopup.vue'
import barGraph from '@/components/graphs/BarGraph.vue'
import donutGraph from '@/components/graphs/DonutGraph.vue'
import donutTableGraph from '@/components/graphs/DonutTableGraph.vue'

export default {
    components: {
        exportReportPopup,
        barGraph,
        donutGraph,
        donutTableGraph,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            graphIds: [
                'customer-by-age',
                'customers-by-gender',
                'customers-by-work-type',
                'customers-account-by-month',
                'customers-by-industry',
                'customers-by-nationality',
                'customers-by-residence',
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dashboardData', 'hasScopes']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        setQueryParams(groupBy) {
            let query = {
                startDate: this.$moment()
                    .subtract(10, 'days')
                    .format('YYYY-MM-DD'),
                endDate: this.$moment().format('YYYY-MM-DD'),
                groupBy: groupBy,
            }
            return query
        },
    }, // End of Component > methods
} // End of export default
</script>
